import React, { ReactElement } from 'react';
import { MetaTagsProps } from '../types';

export const MetaTags = ({ config, seo }: MetaTagsProps): (ReactElement | null)[] => {
  const { androidId, title, themeColor, keywords } = config;

  const metaTags = [
    { name: 'description', content: seo.description },
    { name: 'google-play-app', content: `app-id=${androidId}` },
    { name: 'application-name', content: title },
    { name: 'theme-color', content: themeColor },
    { name: 'keywords', content: keywords },
  ];

  return metaTags.map(metaTag => (metaTag.content ? <meta key={metaTag.name} {...metaTag} /> : null));
};
